import React, { useEffect, useState, useRef } from 'react'
import { Button, Card, Form, Select, DatePicker, Checkbox, Skeleton, message, Table, ConfigProvider, Collapse, TreeSelect } from "antd";
import { useStoreUpdaterWithAPI } from "../../../../../../Hooks/UseStoreUpdaterWithApi";
import { APIConstants } from "../../../../../../Common/APIConstants";
import { useSelector } from "react-redux";
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import dayjs from "dayjs";
import * as echarts from 'echarts';
import "../../../../../../App.css"
import * as XLSX from "xlsx";
import {
    generatedISOFormatDateString,
    getLastDayRange,
    getLastDayTimeRangeUTC,
} from "../../../../../../Utils/DateConverstion";
import { useCallback } from 'react';
const { Panel } = Collapse;
const { RangePicker } = DatePicker;
const MAX_DAYS = 90;
import weekday from "dayjs/plugin/weekday";
import weekOfYear from "dayjs/plugin/weekOfYear";
import customParseFormat from "dayjs/plugin/customParseFormat";

// Extend plugins
dayjs.extend(weekday);
dayjs.extend(weekOfYear);
dayjs.extend(customParseFormat);

const GroupReport = () => {
    const [groupname, setGroupname] = useState([]);
    const { makeRequest } = useStoreUpdaterWithAPI();
    const [fromDateObj, setFromDateObj] = useState(null);
    const [fromDateString, setFromDateString] = useState(null);
    const [toDateObj, setToDateObj] = useState(null);
    const [toDateString, setToDateString] = useState(null);
    const [isLast24Hours, setIsLast24Hours] = useState(false);
    const [fromDateError, setFromDateError] = useState();
    const [toDateError, setToDateError] = useState();
    const [time, setTime] = useState(false);
    const [to, setTo] = useState(null);
    const [from, setFrom] = useState(null);
    const mode = useSelector((state) => state.darkMode);
    const { isdarkMode } = mode;
    const [groupID, setGroupId] = useState(null);
    const [rowData, setRowData] = useState([]);
    const [chartData, setChartData] = useState([]);
    const [chartData2, setChartData2] = useState([]);
    const [loading, setLoading] = useState(true)
    const chartRef = useRef(null);
    const chartRef2 = useRef(null);
    const [subGroupData, setSubGroupData] = useState([]);
    const [groupDetails, setGroupDetails] = useState([]);
    const [showData, setShowData] = useState(false);
    const [chartExcel, setChartExcel] = useState([]);
    const [excelToDate, setExcelToDate] = useState(null);
    const [excelFromDate, setExcelFromDate] = useState(null);
      const [showCalendar, setShowCalendar] = useState(false);
      const [value, setValue] = useState([dayjs().add(-7, 'd'), dayjs()]);

    setTimeout(() => {
        setLoading(false)
    }, 2000)

    useEffect(() => {
        makeRequest({
            type: APIConstants.POST,
            url: `${APIConstants.ELECTRICAL_GROUP_NAME}`,
        }).then((res) => {
            if(res){
                setGroupname(res);
            }
        });
    }, [])

    const onChangeFromDate = (dateString) => {
        setFromDateString(dateString);
        setFromDateObj(dateString);
        if (dateString) {
            setFromDateError("");
        }
    };

    const onChangeToDate = (dateString) => {
        setToDateString(dateString);
        setToDateObj(dateString);
        if (dateString) {
            setToDateError("");
        }
    };

    const handleTimeRangeChange = () => {
        console.log('first')
        const range = getLastDayTimeRangeUTC();
        console.log('From:', range.from);
        console.log('To:', range.to); 

        console.log(getLastDayRange())
        const now = dayjs();
        const fromTime = now.subtract(24, "hour");
        const fromTimeString = fromTime.format("YYYY-MM-DD HH:mm:ss");
        const toTimeString = now.format("YYYY-MM-DD HH:mm:ss");
        console.log(toTimeString)
        setFromDateObj(null);
        setToDateObj(null);
        setFromDateString(range.from);
        setToDateString(range.to);
        setFrom(range.from);
        setTo(range.to);
        // setFromDateString(fromTimeString);
        // setToDateString(toTimeString);
        // setFrom(fromTimeString);
        // setTo(toTimeString);
    }; 

    const handleCheckboxChange = (e) => {
        const { checked } = e.target;
        setIsLast24Hours(checked);
        setTime(!checked);

        if (checked) {
            handleTimeRangeChange();
        } else {
            setFromDateString(null);
            setToDateString(null);
            setFromDateObj(null);
            setToDateObj(null);
        }
    };

    const setInputData = () => {
        const fromDate = new Date(fromDateString || new Date());
        const toDate = new Date(toDateString || new Date());

        if (isLast24Hours) {
            // const now = new Date();
            // fromDate.setHours(now.getHours() - 24);
            // toDate.setHours(now.getHours());
        }
        const range = getLastDayTimeRangeUTC();
        console.log('From:', range.from);
        console.log('To:', range.to);
        console.log(isLast24Hours)

        const formattedFromDate = generatedISOFormatDateString(fromDate);
        const formattedToDate = generatedISOFormatDateString(toDate);
        console.log(formattedFromDate)
        console.log(fromDate)

        const inputData1 = {
            GroupId: groupID,
            FromDate: (range.from),
            ToDate: (range.to),
        };
        const inputData2 = {
            GroupId: groupID,
            FromDate: formattedFromDate,
            ToDate: formattedToDate,
        };
        console.log("Date ", inputData2);
        console.log("Date ", inputData1);

        if(isLast24Hours){
            getResponse(inputData1);

        }else{
            getResponse(inputData2);
        }

    };

    const getResponse = (inputData) => {
        setShowData(false)
        console.log(inputData)
        setExcelFromDate(inputData?.FromDate)
        setExcelToDate(inputData?.ToDate)
        makeRequest({
            type: APIConstants.GET,
            url: `${APIConstants.ELECTRICAL_GROPU_REPORT}?GroupID=${inputData.GroupId}&FromDate=${inputData.FromDate}&ToDate=${inputData.ToDate}`,
        }).then((res) => {
            console.log('API Response:', res);

            // {
            //     groupID: 10,
            //     groupName: 'DG',
            //     subGroupConsumption: -3,
            //     subgroupID: 11,
            //     subgroupName: 'DG',
            //     calSubGroupID: 10011
            //   },
            if (res) {
                if (res.grouptableDetails && Array.isArray(res.grouptableDetails)) {
                    const formattedData = res.grouptableDetails.map(item => ({
                        groupID: item.groupID,
                        groupName: item.groupName,
                        groupConsumption: item.groupConsumption,
                    }));
                    const formattedDataSub = res.subgrouptableDetails.map(item => ({
                        // groupID: item.subgroupID,
                        name: item.subgroupName,
                        value: item.subGroupConsumption,
                    }));
                    console.log(formattedDataSub)

                    if (res.groupsDetails && Array.isArray(res.groupsDetails)) {
                        const groupDetails = res.groupsDetails.map(item => ({
                            metername: item.metername,
                            openingReading: item.openingReading,
                            closingReading: item.closingReading,
                            finalReading: item.finalReading,
                            siteid: item.siteid,
                            sitename: item.sitename,
                        }));
                        console.log("Group details:", groupDetails);
                    }

                    setRowData(formattedData);
                    console.log("Formatted Data:", formattedData);
                    setSubGroupData(res.subgrouptableDetails);
                    setGroupDetails(res.groupsDetails);
                    console.log("Subgroup Details:", res.subgrouptableDetails);


                    const transformedData = formattedData.map(item => ({
                        name: item.groupName,
                        value: item.groupConsumption,
                    }));
                    setChartData(transformedData);
                    setChartData2(formattedDataSub);
                    console.log("Transformed Chart Data:", transformedData);
                    setShowData(true)
                    setChartExcel(res)
                    updateChartOptions(transformedData);
                    showData(true)

                } else {
                    message.error("Invalid group data in response.");
                }
            } else {
                message.error("API response is empty or invalid.");
            }
        }).catch((error) => {
            console.error('Error fetching data:', error);
            // message.error("There was an error fetching the data.");
        });
    };


    const handleCreateReport = () => {
        const inputData = { GroupId: groupID };
        setInputData()
    }

    const updateChartOptions = (data) => {
        console.log(data)
        const chartInstance = echarts.init(chartRef.current);
        const option = {
            title: {},
            tooltip: {
                trigger: 'item'
            },
            legend: {
                orient: 'horizontal',
                bottom: "0px",
                textStyle: {
                    color: isdarkMode ? 'white' : 'black',
                },
            },
            toolbox: {
                show: true,
                orient: 'horizontal',
                left: 'right',
                top: 'top',
                feature: {
                    // myExport: {
                    //     show: true,
                    //     title: "Export to Excel",
                    //     icon: "path://M5 0L15 10L5 20Z",
                    //     onclick: () => {
                    //         console.log(chartExcel)
                    //         const { grouptableDetails, subgrouptableDetails, groupsDetails } = chartExcel;
                        
                    //         // Prepare rows for the Excel sheet
                    //         const rows = [];
                        
                    //         grouptableDetails.forEach((group) => {
                    //             // Add the group row
                    //             rows.push([group.groupID, group.groupName, group.groupConsumption || 0]);
                        
                    //             // Find subgroups for this group
                    //             const subgroups = subgrouptableDetails.filter(
                    //                 (subgroup) => subgroup.groupID === group.groupID
                    //             );
                        
                    //             subgroups.forEach((subgroup) => {
                    //                 // Add the subgroup row
                    //                 rows.push([
                    //                     "",
                    //                     "Sub GroupID",
                    //                     "Sub Group Name",
                    //                     "Final Reading",
                    //                 ]);
                    //                 rows.push([
                    //                     "",
                    //                     subgroup.subgroupID,
                    //                     subgroup.subgroupName,
                    //                     subgroup.subGroupConsumption || 0,
                    //                 ]);
                        
                    //                 // Add the site details header row
                    //                 rows.push([
                    //                     "",
                    //                     "",
                    //                     "Site Name",
                    //                     "SubGroup ID",
                    //                     "Meter ID",
                    //                     "Meter Name",
                    //                     "Opening Reading",
                    //                     "Closing Reading",
                    //                     "Final Reading",
                    //                 ]);
                        
                    //                 // Find site details for this subgroup
                    //                 const sites = groupsDetails.filter(
                    //                     (site) => site.subgroupID === subgroup.subgroupID
                    //                 );
                        
                    //                 sites.forEach((site) => {
                    //                     rows.push([
                    //                         "",
                    //                         "",
                    //                         site.sitename || "",
                    //                         site.subgroupID || "",
                    //                         site.meterid || "",
                    //                         site.metername || "",
                    //                         site.openingReading || 0,
                    //                         site.closingReading || 0,
                    //                         site.finalReading || 0,
                    //                     ]);
                    //                 });
                    //             });
                    //         });
                        
                    //         // Define the headers
                    //         const headers = [
                    //             "Group ID",
                    //             "Group Name",
                    //             "Total Consumption",
                    //             "",
                    //             "",
                    //             "",
                    //             "",
                    //             "",
                    //         ];
                        
                    //         // Combine headers and rows into a single dataset
                    //         const excelData = [headers, ...rows];
                    //         console.log("Excel data:", excelData);
                        
                    //         // Create the Excel workbook and worksheet
                    //         const workbook = XLSX.utils.book_new();
                    //         const worksheet = XLSX.utils.aoa_to_sheet(excelData);
                    //         XLSX.utils.book_append_sheet(workbook, worksheet, "GroupReport");
                        
                    //         // Generate the filename with a timestamp
                    //         const now = new Date();
                    //         const timestamp = now
                    //             .toLocaleString("en-US", {
                    //                 year: "numeric",
                    //                 month: "2-digit",
                    //                 day: "2-digit",
                    //                 hour: "2-digit",
                    //                 minute: "2-digit",
                    //                 second: "2-digit",
                    //                 hour12: false,
                    //             })
                    //             .replace(/[/,: ]/g, "-");
                        
                    //         const filename = `Group_Report_${timestamp}.xlsx`;
                    //         console.log("Generated Filename:", filename);
                        
                    //         // Write the file to the user's system
                    //         XLSX.writeFile(workbook, filename);
                    //     },
                    // },
                    mark: { show: true },
                    saveAsImage: { show: true },
                },
                iconStyle: {
                    borderColor: isdarkMode ? 'white' : 'black',
                },
                emphasis: {
                    iconStyle: {
                        borderColor: isdarkMode ? '#FFD700' : '#1E90FF',
                    },
                },
            },
            series: [
                {
                    name: 'Group Consumption',
                    type: 'pie',
                    radius: '50%',
                    data: data,
                    emphasis: {
                        itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    }
                }
            ]
        };
        chartInstance.setOption(option);
        
    };
    const updateChartOptions2 = (data) => {
        console.log(data)
        const chartInstance = echarts.init(chartRef2.current);
        const option = {
            title: {},
            tooltip: {
                trigger: 'item'
            },
            legend: {
                orient: 'horizontal',
                bottom: "0px",
                textStyle: {
                    color: isdarkMode ? 'white' : 'black',
                },
            },
            toolbox: {
                show: true,
                orient: 'horizontal',
                left: 'right',
                top: 'top',
                feature: {
                    // myExport: {
                    //     show: true,
                    //     title: "Export to Excel",
                    //     icon: "path://M5 0L15 10L5 20Z",
                    //     onclick: () => {
                    //         console.log(chartExcel)
                    //         const { grouptableDetails, subgrouptableDetails, groupsDetails } = chartExcel;
                        
                    //         // Prepare rows for the Excel sheet
                    //         const rows = [];
                        
                    //         grouptableDetails.forEach((group) => {
                    //             // Add the group row
                    //             rows.push([group.groupID, group.groupName, group.groupConsumption || 0]);
                        
                    //             // Find subgroups for this group
                    //             const subgroups = subgrouptableDetails.filter(
                    //                 (subgroup) => subgroup.groupID === group.groupID
                    //             );
                        
                    //             subgroups.forEach((subgroup) => {
                    //                 // Add the subgroup row
                    //                 rows.push([
                    //                     "",
                    //                     "Sub GroupID",
                    //                     "Sub Group Name",
                    //                     "Final Reading",
                    //                 ]);
                    //                 rows.push([
                    //                     "",
                    //                     subgroup.subgroupID,
                    //                     subgroup.subgroupName,
                    //                     subgroup.subGroupConsumption || 0,
                    //                 ]);
                        
                    //                 // Add the site details header row
                    //                 rows.push([
                    //                     "",
                    //                     "",
                    //                     "Site Name",
                    //                     "SubGroup ID",
                    //                     "Meter ID",
                    //                     "Meter Name",
                    //                     "Opening Reading",
                    //                     "Closing Reading",
                    //                     "Final Reading",
                    //                 ]);
                        
                    //                 // Find site details for this subgroup
                    //                 const sites = groupsDetails.filter(
                    //                     (site) => site.subgroupID === subgroup.subgroupID
                    //                 );
                        
                    //                 sites.forEach((site) => {
                    //                     rows.push([
                    //                         "",
                    //                         "",
                    //                         site.sitename || "",
                    //                         site.subgroupID || "",
                    //                         site.meterid || "",
                    //                         site.metername || "",
                    //                         site.openingReading || 0,
                    //                         site.closingReading || 0,
                    //                         site.finalReading || 0,
                    //                     ]);
                    //                 });
                    //             });
                    //         });
                        
                    //         // Define the headers
                    //         const headers = [
                    //             "Group ID",
                    //             "Group Name",
                    //             "Total Consumption",
                    //             "",
                    //             "",
                    //             "",
                    //             "",
                    //             "",
                    //         ];
                        
                    //         // Combine headers and rows into a single dataset
                    //         const excelData = [headers, ...rows];
                    //         console.log("Excel data:", excelData);
                        
                    //         // Create the Excel workbook and worksheet
                    //         const workbook = XLSX.utils.book_new();
                    //         const worksheet = XLSX.utils.aoa_to_sheet(excelData);
                    //         XLSX.utils.book_append_sheet(workbook, worksheet, "GroupReport");
                        
                    //         // Generate the filename with a timestamp
                    //         const now = new Date();
                    //         const timestamp = now
                    //             .toLocaleString("en-US", {
                    //                 year: "numeric",
                    //                 month: "2-digit",
                    //                 day: "2-digit",
                    //                 hour: "2-digit",
                    //                 minute: "2-digit",
                    //                 second: "2-digit",
                    //                 hour12: false,
                    //             })
                    //             .replace(/[/,: ]/g, "-");
                        
                    //         const filename = `Group_Report_${timestamp}.xlsx`;
                    //         console.log("Generated Filename:", filename);
                        
                    //         // Write the file to the user's system
                    //         XLSX.writeFile(workbook, filename);
                    //     },
                    // },
                    mark: { show: true },
                    saveAsImage: { show: true },
                },
                iconStyle: {
                    borderColor: isdarkMode ? 'white' : 'black',
                },
                emphasis: {
                    iconStyle: {
                        borderColor: isdarkMode ? '#FFD700' : '#1E90FF',
                    },
                },
            },
            series: [
                {
                    name: 'Group Consumption',
                    type: 'pie',
                    radius: '50%',
                    data: data,
                    emphasis: {
                        itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    }
                }
            ]
        };
        chartInstance.setOption(option);
        
    };
    const exportToExcel = (chartExcel, fromDate, toDate) => {
        console.log(chartExcel);
        const { grouptableDetails, subgrouptableDetails, groupsDetails } = chartExcel;
    
        // Format the dates
        const formattedFromDate = fromDate.replace('T', ' ').replace('.000Z', ' ') || "";
        const formattedToDate = toDate.replace('T', ' ').replace('.000Z', ' ') || "";
    
        // Prepare rows for the Excel sheet
        const rows = [];
    
        // Define the headers
        const headers = [
            "Group ID",
            "Group Name",
            "Total Consumption",
            "",
            "",
            "",
            "",
            "",
            // "From Date",
            // "To Date",
        ];
    
        rows.push(headers);
    
        grouptableDetails.forEach((group) => {
            // Add the group row
            rows.push([
                group.groupID,
                group.groupName,
                group.groupConsumption || 0,
                "",
                "",
                "",
                "",
                "",
                "", // Leave "From Date" blank
                "", // Leave "To Date" blank
            ]);
    
            // Find subgroups for this group
            const subgroups = subgrouptableDetails.filter(
                (subgroup) => subgroup.groupID === group.groupID
            );
    
            subgroups.forEach((subgroup) => {
                // Add the subgroup row
                rows.push([
                    "",
                    "Sub GroupID",
                    "Sub Group Name",
                    "Final Reading",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "", // Leave "From Date" blank
                    "", // Leave "To Date" blank
                ]);
                rows.push([
                    "",
                    subgroup.subgroupID,
                    subgroup.subgroupName,
                    subgroup.subGroupConsumption || 0,
                    "",
                    "",
                    "",
                    "",
                    "",
                    "", // Leave "From Date" blank
                    "", // Leave "To Date" blank
                ]);
    
                // Add the site details header row
                rows.push([
                    "",
                    "",
                    "Site Name",
                    "SubGroup ID",
                    "Meter ID",
                    "Meter Name",
                    "Opening Reading",
                    "Closing Reading",
                    "Final Reading",
                    "",
                    "", // Leave "From Date" blank
                ]);
    
                // Find site details for this subgroup
                const sites = groupsDetails.filter(
                    (site) => site.subgroupID === subgroup.subgroupID
                );
    
                sites.forEach((site) => {
                    rows.push([
                        "",
                        "",
                        site.sitename || "",
                        site.subgroupID || "",
                        site.meterid || "",
                        site.metername || "",
                        site.openingReading || 0,
                        site.closingReading || 0,
                        site.finalReading || 0,
                        "", // Leave "From Date" blank
                        "", // Leave "To Date" blank
                    ]);
                });
            });
        });
    
        // Add the From Date and To Date at the end of the rows
        rows.push([]);
        rows.push([
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "From Date",
            formattedFromDate,
        ]);
        rows.push([
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "To Date",
            formattedToDate,
        ]);
    
        // Create the Excel workbook and worksheet
        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.aoa_to_sheet(rows);
    
        // Apply styles for alternate rows and date rows
        const range = XLSX.utils.decode_range(worksheet["!ref"]);
        for (let rowNum = range.s.r; rowNum <= range.e.r; rowNum++) {
            for (let colNum = range.s.c; colNum <= range.e.c; colNum++) {
                const cellAddress = XLSX.utils.encode_cell({ r: rowNum, c: colNum });
                if (!worksheet[cellAddress]) continue;
    
                // Get the cell object
                const cell = worksheet[cellAddress];
    
                // Apply background color
                if (rowNum % 2 === 1) {
                    cell.s = {
                        fill: { fgColor: { rgb: "D3D3D3" } }, // Light grey for alternate rows
                    };
                }
    
                // Apply color for "From Date" and "To Date" rows
                if (rowNum === rows.length - 2 || rowNum === rows.length - 1) {
                    cell.s = {
                        fill: { fgColor: { rgb: "FFFF00" } }, // Yellow for date rows
                    };
                }
            }
        }
    
        // Append the worksheet to the workbook
        XLSX.utils.book_append_sheet(workbook, worksheet, "GroupReport");
    
        // Generate the filename with a timestamp
        const now = new Date();
        const timestamp = now
            .toLocaleString("en-US", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
                hour12: false,
            })
            .replace(/[/,: ]/g, "-");
    
        const filename = `Group_Report_${timestamp}.xlsx`;
        console.log("Generated Filename:", filename);
    
        // Write the file to the user's system
        XLSX.writeFile(workbook, filename);
    };

    useEffect(() => {
        if (chartRef.current && chartData.length > 0) {
            updateChartOptions(chartData,chartExcel);
        }
    }, [chartData,isdarkMode,chartExcel]);
    useEffect(() => {
        if (chartRef2.current && chartData2.length > 0) {
            updateChartOptions2(chartData2,chartExcel);
        }
    }, [chartData,isdarkMode,chartExcel]);

    const columns = [
        { title: "Group ID", dataIndex: "groupID", key: "groupID" },
        { title: "Group Name", dataIndex: "groupName", key: "groupName" },
        { title: "Group Consumption", dataIndex: "groupConsumption", key: "groupConsumption" },
    ];

    const expandedRowRender = (record) => {
        const groupID = record.groupID;
        console.log(groupID)
        console.log(record)

        const subgroupColumns = [
            { title: "Subgroup ID", dataIndex: "subgroupID", key: "subgroupID" },
            { title: "Subgroup Name", dataIndex: "subgroupName", key: "subgroupName" },
            { title: "Subgroup Consumption", dataIndex: "subGroupConsumption", key: "subGroupConsumption" },
        ];

        const groupColumns = [
            { title: "Site ID", dataIndex: "siteid", key: "siteid" },
            { title: "Sub Group ID", dataIndex: "subgroupID", key: "subgroupID" },
            { title: "Site Name", dataIndex: "sitename", key: "sitename" },
            { title: "Meter Name", dataIndex: "metername", key: "metername" },
            { title: "Opening Reading", dataIndex: "openingReading", key: "openingReading" },
            { title: "Closing Reading", dataIndex: "closingReading", key: "closingReading" },
            { title: "Final Reading", dataIndex: "finalReading", key: "finalReading" },
        ];


        const subgroupData = subGroupData.filter(subgroup => subgroup.groupID === groupID);
        const groupDetailData = groupDetails.filter(detail => detail.groupID === groupID);

        console.log(subgroupData)
        console.log(groupDetailData)
        return ( 
            <div>
                {/* Subgroup Details Table */}
                <Table
                    columns={subgroupColumns}
                    dataSource={subgroupData}
                    rowKey="subgroupID"
                    pagination={false}
                    title={() => 'Subgroup Details'}
                    expandable={{
                        expandedRowRender: (subgroupRecord) => {
                            console.log(subgroupRecord)
                            console.log(groupDetailData) 
                            const grouData = groupDetailData.filter(detail => detail.subgroupID === subgroupRecord.subgroupID);
                            console.log(grouData)
                            return (
                                <Table
                                    columns={groupColumns}
                                    dataSource={groupDetailData.filter(detail => detail.subgroupID === subgroupRecord.subgroupID)}
                                    rowKey="siteid"
                                    pagination={false}
                                    title={() => 'Meter Details'}
                                    className="mt-3"
                                />
                            );
                        },
                        rowExpandable: (subgroupRecord) => true,
                    }}
                />
            </div>
        );
    };

    console.log(chartData) 

    const handleTable= (value)=>{
        setGroupId(value)
        setRowData([])
        setChartData([])
        setChartExcel([])
        // chartRef.current = '';

    }
    const color = useSelector((state) => state.ThemeChange);
    console.log(color)
    useEffect(() => {
        document.documentElement.style.setProperty("--date-ok-btn", color.themeConfig.colorPrimary);
        document.documentElement.style.setProperty("--date-now-btn", "#fff");
      }, [color]);

      console.log(groupname)
      const treeData = groupname?.map((item,index) => ({
        key: index,
        title: item.department,
        value: item.groupID,
      }));
      console.log(treeData)

      
      
  const today = dayjs();
  const startOfWeek = dayjs().weekday(0); // Sunday
  const endOfWeek = dayjs().weekday(6);   // Saturday
  const startOfLastWeek = dayjs().subtract(1, "week").weekday(0);
  const endOfLastWeek = dayjs().subtract(1, "week").weekday(6);
  const startOfMonth = dayjs().startOf("month");
  const endOfMonth = dayjs().endOf("month");
  const startOfLastMonth = dayjs().subtract(1, "month").startOf("month");
  const endOfLastMonth = dayjs().subtract(1, "month").endOf("month");
  
  const rangePresets = [
    // { label: "Today", value: [today.startOf("day"), today.endOf("day")] },
    // { label: "Yesterday", value: [today.subtract(1, "day").startOf("day"), today.subtract(1, "day").endOf("day")] },
    { label: "This Week", value: [startOfWeek, endOfWeek] },
    { label: "Last Week", value: [startOfLastWeek, endOfLastWeek] },
    { label: "This Month", value: [startOfMonth, endOfMonth] },
    { label: "Last Month", value: [startOfLastMonth, endOfLastMonth] },
    { label: "Last 7 Days", value: [dayjs().subtract(7, "day"), today] },
    { label: "Last 14 Days", value: [dayjs().subtract(14, "day"), today] },
    { label: "Last 30 Days", value: [dayjs().subtract(30, "day"), today] },
    { label: "Last 90 Days", value: [dayjs().subtract(90, "day"), today] },
  ];
          const handleDateChange = (value) => {
            if (!value) return;
            const diff = value[1]?.diff(value[0], "day");
        
            if (diff > MAX_DAYS) {
              alert("Date range cannot exceed 90 days");
              return;
            }
            
            if (value) {
              // const fromDate = value[0];
              // const toDate = value[1];
              const fromDate = value[0]?.format("YYYY-MM-DD HH:mm:ss");
              const toDate = value[1]?.format("YYYY-MM-DD HH:mm:ss");
        
              console.log([fromDate, toDate]);
            setValue([value[0], value[1]]);
              onChangeFromDate(fromDate);
              onChangeToDate(toDate);
            } else {
              // setDates(null);
            }
          };
    
    return (
        loading &&!showData ? (
            <>
                <Skeleton active paragraph={{ rows: 6 }} />
            </>
        ) : (
            <div>
                <h4 className={`text-left text-[20px] mb-5 dark ${isdarkMode ? 'darkfont' : 'whitemode'}`}>GROUP REPORT</h4>
                <Collapse className={`w-full h-auto dark  rounded-b-lg rounded-t-sm ${!isdarkMode ? 
                    "bg-slate-50 " : "bg-slate-900"} `}>
                <Panel header="SELECTION" key="1"className={`no-panel-padding font-[600] text-[18px] dark ${isdarkMode ? 'darkfont' : 'whitemode'}`}     style={{ padding: 0 }}>

                <Card  className={`w-full m-0 h-auto dark ${!isdarkMode ? "bg-slate-50 border-0" : "bg-slate-900"} `}>
                    {/* <p className={`font-[600] text-[18px] dark ${isdarkMode ? 'darkfont' : 'whitemode'}`}>SELECTION</p> */}

                    <div >
                        <div className='flex gap-5 mt-5 '>
                            <div className="flex gap-8">
                                <div className='flex flex-col gap-3'>
                                <div className="flex ">
                                <label className={` mr-3 w-24 ${isdarkMode ? 'darkfont' : 'whitemode'}`}>Group Name</label>
                                    <div
                                        // label="Group Name"
                                        name="groupname"
                                        className={` ${isdarkMode ? 'darktext' : 'lighttext'}`}
                                        rules={[{ required: true, message: "Please select Group Name!" }]}
                                    >
                                        <TreeSelect
                                            mode="multiple"
                                            placeholder="Select Group Name"
                                            onChange={(value) => handleTable(value)}
                                            style={{ width: "320px" }}
                                            showSearch
                                            filterOption={(input, option) => {
                                                return option.children.toLowerCase().includes(input.toLowerCase());
                                            }}
                                            treeCheckable={true}
                                            treeData={treeData}
                                            maxTagCount={2}
                                            dropdownClassName={isdarkMode ? 'select-dropdown-background' : 'light-mode-dropdown'}
                                            className={`  ${isdarkMode ? 'custom-select-dark select-dropdown-background' : 'custom-select-light'}`}
                                        >
                                            {/* {groupname.map((group) => (
                                                <Select.Option key={group.groupID} value={group.groupID}>
                                                    {group.department}
                                                </Select.Option>
                                            ))} */}
                                        </TreeSelect>
                                    </div>
                                </div>
                                <div className=" flex ">
                                                {/* <div><label className={` dark ${isdarkMode ? 'darkfont' : 'whitemode'}`}>From Date:</label></div> */}
                                                  {/* <label className={` mr-5  ${isdarkMode ? 'darkfont' : 'whitemode'}`}>From Date</label> */}
                                                  <label className="mr-3 w-24  text-left"> Date:</label>
                                                <div
                                                    // name="Date"
                                                    // label="From Date"
                                                    rules={[{ required: true, message: "Please select From Date!" }]}
                                                    className={`dark  ${isdarkMode ? 'darkfont' : 'whitemode'}`}
                                                >
            <RangePicker
      value={value}
      onChange={handleDateChange}
      popupClassName="custom-picker"
      presets={rangePresets}
      format="YYYY-MM-DD HH:mm:ss"
      showTime={{ format: "HH:mm:ss" }}
      className={`w-80 ml-0 shadow-lg rounded-3xl  ${
        isdarkMode
          ? "customRangePicker-dark  text-white"
          : "customRangePicker-light text-black"
      }`}
      panelRender={(originalPanel) => {
        if (!showCalendar) {
          return (
            <div
              className={`${
                isdarkMode ? "bg-[#1a1a1a]" : "bg-white"
              } flex flex-col gap-1 p-2 w-44 rounded`}
            >
              {rangePresets.map((preset) => (
                <div
                  key={preset.label}
                  onClick={() => handleDateChange(preset.value)}
                  className={`cursor-pointer px-2 py-1 rounded ${
                    isdarkMode
                      ? "text-white hover:bg-gray-700"
                      : "text-black hover:bg-gray-200"
                  }`}
                >
                  {preset.label}
                </div>
              ))}
              <button
                onClick={() => setShowCalendar(true)}
                className={`mt-2 px-2 py-1 rounded  border text-center ${
                  isdarkMode
                    ? "bg-[#1a1a1a] border-white text-white hover:bg-gray-700"
                    : "bg-white border-black text-black hover:bg-gray-200"
                }`}
              >
                Custom Dates
              </button>
            </div>
          );
        }
        return originalPanel;
      }}
      onOpenChange={(open) => {
        if (!open) setShowCalendar(false);
      }}
    />
                                                </div>
                                            </div>
                                </div>
                            </div>
                          
                      <Button type= {isdarkMode? "":'primary'} htmlType="submit" onClick={handleCreateReport} className=" ml-10 mt-4">
                                Create Report
                            </Button>
                          
                        </div>
                    </div>
                </Card>
  </Panel>
                </Collapse>
                {
                    showData&&(
                    <Card className={`w-full h-auto dark ${!isdarkMode ? "bg-slate-50 border-0" : "bg-slate-900"} mt-10`}>
                        <div className="flex justify-between items-center">
                        <p className={`font-[600] text-[18px] dark ${isdarkMode ? 'darkfont' : 'whitemode'}`}>GRID VIEW</p>
                        <Button type="primary" onClick={()=>exportToExcel(chartExcel,excelFromDate,excelToDate)} className=" ml-10">
                                Create Excel
                            </Button>
                        </div>
                        <div className={`${isdarkMode ? "dark-table" : "white-table "}  `} 
                        style={{
                            '--table-header-bg': color.themeConfig.colorPrimary, 
                            '--table-header-text': '#fff', 
                            height: "auto", width: "100%", overflowY: "auto" 
                          }}
                          >
                            <Table
                                columns={columns}
                                dataSource={rowData}
                                rowKey="groupID"
                                pagination={false}
                                rowHoverable={false}
                                className={`${isdarkMode ? "dark-table" : "white-table "}`}
                                
                                expandable={{
                                    expandedRowRender,
                                    rowExpandable: (record) => {
                                        const subgroupData = subGroupData.filter(subgroup => subgroup.groupID === record.groupID);
                                        return subgroupData.length > 0;
                                    },
                                }}
                            />
                        </div>
                    </Card>
                    )
                }

                {
                    showData&&(
                        <div className=" w-full flex ">

                    <Card className={`w-1/2 h-auto dark  ${!isdarkMode ? "bg-slate-50 border-0" : "bg-slate-900"} mt-10`}>
                        <p className={`font-[600] text-[18px] dark ${mode.isdarkMode ? 'darkfont' : 'whitemode'}`}>PIECHART (Group)</p>
                        <div ref={chartRef} className="w-full h-full sm:h-[300px] md:h-[400px] lg:h-[500px]"></div>
                    </Card>
                    <Card className={`w-1/2 h-auto dark  ${!isdarkMode ? "bg-slate-50 border-0" : "bg-slate-900"} mt-10`}>
                        <p className={`font-[600] text-[18px] dark ${mode.isdarkMode ? 'darkfont' : 'whitemode'}`}>(Sub Group)</p>
                        <div ref={chartRef2} className="w-full h-full sm:h-[300px] md:h-[400px] lg:h-[500px]"></div>
                    </Card>
                        </div>
                    )
                }
                <style>
        {`
          .custom-picker .ant-picker-ok .ant-btn{
            background-color: var(--date-ok-btn) !important;
            border-color: var(--date-ok-btn) !important;
            color: white !important;
          }
          .custom-picker .ant-picker-ok .ant-btn:hover {
            background-color: var(--date-ok-btn) !important;
            border-color: #d9363e !important;
          }
          .custom-picker .ant-picker-now .ant-picker-now-btn {
            color: var(--date-ok-btn) !important;
          }
           .custom-picker .anticon-swap-right, .anticon-calendar{
            color: var(--date-ok-btn) !important;
          }
        `}
      </style>
            </div>
        )


    )
}

export default GroupReport